import { render, staticRenderFns } from "./ProFeatures.vue?vue&type=template&id=2256b50e&"
import script from "./ProFeatures.vue?vue&type=script&lang=js&"
export * from "./ProFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports